<template>
  <div class="apply_box sing_box">
    <div class="top">根据对您的信息检测，当前可借的金额和期限如下</div>
    <div class="con_box">
      <div class="item">
        <div class="l_box">
          <p class="title"><span class="line"></span> 借多少</p>
          <p class="info">最低可借{{ minMoney }}元，最高可借{{ maxMoney }}元</p>
        </div>
        <div class="r_box">
          <Input
            v-model="inputVal"
            icon="ios-arrow-forward"
            placeholder="请输入"
            @on-blur="onblur"
            type="number"
          />
          <!-- <Select v-model="model1">
            <Option v-for="item in cityList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select> -->
        </div>
      </div>
      <div class="bg"></div>
      <div class="item">
        <div class="l_box">
          <p class="title"><span class="line"></span> 借多久</p>
          <p class="info">金额不同 可借款的期数不同</p>
        </div>
        <div class="r_box">
          <Select v-model="limitModel">
            <Option
              v-for="(item, index) in limitList"
              :value="item"
              :key="index"
              >{{ item }}期</Option
            >
          </Select>
        </div>
      </div>
      <div class="bg"></div>
      <div class="item">
        <div class="l_box">
          <p class="title"><span class="line"></span> 还多少</p>
          <p class="info">根据选择金额和期数，预估还款金额</p>
        </div>
        <div class="r_box">
          <span class="look" @click="toShow"
            >查看明细 <Icon type="ios-arrow-forward" class="look_icon"
          /></span>
        </div>
      </div>
    </div>

    <div class="bg"></div>

    <div class="btn_box">
      <div class="loan_btn pay_btn_succ" @click="toLoan()">下一步</div>
    </div>

    <div class="shadow" v-if="isShow"></div>
    <div class="toast" v-if="isShow">
      <h1 class="title">
        费用明细 <span class="close_btn" @click="toHide"></span>
      </h1>
      <Timeline v-if="dataList.length > 0">
        <Timeline-item v-for="(item, index) in dataList" :key="index">
          <div class="box">
            <p class="time">{{ item.period }}期</p>
            <p class="content">
              还款时间: {{ item.time }}
              <span class="money">￥{{ item.amount }}</span>
            </p>
          </div>
        </Timeline-item>
      </Timeline>
    </div>
    <applyModal1 :propJson="propJson" @toHide="toHide" />
    <Loading :isShow="isShowLoading"></Loading>
  </div>
</template>

<script>
import applyModal1 from "@/components/applyModal1";
import Loading from "@/components/loading";
export default {
  components: {
    applyModal1,
    Loading
  },
  data() {
    return {
      maxMoney: 10000,
      minMoney: 1000,
      limitNum: 100,
      limitList: [],
      dataList: [
        {
          current_period: "1",
          repay_time: 1579276800,
          repay_amount: 200896
        },
        {
          current_period: "2",
          repay_time: 1581955200,
          repay_amount: 200896
        },
        {
          current_period: "3",
          repay_time: 1584460800,
          repay_amount: 200896
        },
        {
          current_period: "4",
          repay_time: 1587139200,
          repay_amount: 200896
        }
      ],
      limitModel: "",
      inputVal: "",
      isShowLoading: false,
      isShow: false,
      propJson: {
        isShow: false,
        title: "费用明细",
        feeDesc: "122323.2",
        btn: "确定",
        status: "0",
        periodAmount: "2019.12.011",
        interest: "3",
        label1: "期数",
        label2: "还款时间",
        label3: "还款金额(元)"
      },
      timer: null,
      orderId: ""
    };
  },
  beforeDestroy() {
    //清除定时器
    clearInterval(this.timer);
    console.log("beforeDestroy");
  },
  destroyed() {
    //清除定时器
    clearInterval(this.timer);
    console.log("destroyed");
  },
  mounted() {
    this.isShowLoading = true;
    this.orderId = this.$route.query.orderId;
    this.util.title("签约");
    this.getDetails();
  },
  methods: {
    toHide() {
      this.isShow = false;
    },
    onblur() {
      let val1 = Number(this.inputVal);
      let val2 = Number(this.limitNum);
      if (val1 > this.maxMoney) {
        this.inputVal = Number(this.maxMoney);
      } else if (val1 < this.minMoney) {
        this.inputVal = Number(this.minMoney);
      } else {
        this.inputVal = Number(val1 - (val1 % val2));
      }
      this.inputVal = Number(this.inputVal);
      // 获取期数接口
      this.timer = setTimeout(this.getLimit, 1000);
    },
    //获取费用明细
    toShow() {
      let _this = this;
      let param = {
        amount: _this.inputVal,
        period: _this.limitModel
      };
      this.$get("/app/api/v2/yimeifu/trialCalculation/" + this.orderId, param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.dataList = e.data;
            _this.isShow = true;
          } else {
            _this.util.toast({ msg: e.message });
          }
        })
        .catch(error => {});
    },
    getDetails() {
      let _this = this;
      this.$get("/app/api/v2/yimeifu/queryAmount/" + this.orderId)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.maxMoney = e.data[0];
            _this.minMoney = e.data[1];
            _this.limitNum = e.data[2];
            _this.inputVal = _this.maxMoney;
            _this.getLimit();
          } else if (e.code == 501) {
            _this.util.toast({ msg: e.message });
            setTimeout(() => {
              //去状态页面
              this.$router.push({
                path: "/loan/applyDetail",
                query: {
                  orderId: _this.orderId
                }
              });
            }, 1000);
          } else {
            _this.util.toast({ msg: e.message });
          }
        })
        .catch(error => {});
    },
    getLimit() {
      let _this = this;
      let param = {
        amount: _this.inputVal
      };
      this.$get("/app/api/v2/yimeifu/queryPeriod/" + this.orderId, param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.limitList = e.data;
            _this.limitModel = _this.limitList[0];
          } else {
            _this.util.toast({ msg: e.message });
          }
          _this.isShowLoading = false;
        })
        .catch(error => {});
    },
    //去借款
    toLoan() {
      let _this = this;
      _this.isShowLoading = true;
      let param = {
        amount: _this.inputVal,
        period: _this.limitModel
      };
      this.$get("/app/api/v2/yimeifu/signUrl/" + this.orderId, param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            //跳转到易美付——H5借款页面
            window.location.href = e.data;
          } else {
            _this.util.toast({ msg: e.message });
          }
          _this.isShowLoading = false;
        })
        .catch(error => {});
    }
  }
};
</script>
<style scoped>
.apply_box {
  background: #f7f7f7;
  padding-bottom: 0.2rem;
}
.top {
  background: #e6ebff;
  width: 100%;
  height: 0.36rem;
  line-height: 0.36rem;
  text-align: center;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #5983fc;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}

.loanMoney {
  color: #999;
  font-size: 0.12rem;
}
.item {
  display: flex;
  flex: 1;
  justify-content: space-between;
  padding: 0.13rem 0.15rem;
  background: #fff;
}
.l_box {
  flex: 1;
}
.r_box {
  width: 1rem;
  height: 0.3rem;
  line-height: 0.3rem;
  display: inline-block;
  position: relative;
  top: 0.07rem;
}
.title {
  font-size: 0.14rem;
  color: #333;
}
.info {
  font-size: 0.12rem;
  color: #999;
  padding-left: 0.06rem;
  margin-top: 0.06rem;
}
.look {
  display: inline-block;
  border-radius: 15px;
  border: 1px solid rgba(245, 245, 245, 1);
  color: #4f8cfa;
  font-size: 0.13rem;
  width: 1rem;
  height: 0.32rem;
  line-height: 0.28rem;
  padding: 0 0.1rem;
}
.line {
  width: 3px;
  height: 12px;
  background: rgba(72, 108, 255, 1);
  display: inline-block;
}
.pro_item .btn {
  color: #486cff;
  font-size: 0.14rem;
  text-align: center;
  margin: 0 auto;
  padding: 0.1rem;
}

.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.5) 0%,
    rgba(81, 117, 241, 0.5) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
}

.pay_btn_succ {
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.8) 0%,
    rgba(81, 117, 241, 1) 100%
  );
}
.look {
  color: #486cff;
  font-size: 0.13rem;
  float: right;
}
.btn_box {
  margin-top: 0.3rem;
}
.pro_item1 {
  padding: 0.15rem;
  clear: both;
  overflow: hidden;
}
.bank_icon {
  width: 0.26rem;
  height: 0.26rem;
  border-radius: 50%;
  margin-right: 0.1rem;
}
.look_icon {
  color: #808695;
  right: 0.1rem;
  position: absolute;
  top: 0.09rem;
}
.look_input {
  position: absolute;
  top: 0.11rem;
  right: 0.1rem;
}
input::-webkit-input-placeholder {
  font-size: 0.12rem;
}
.shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.4;
  z-index: 112;
}
.toast {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 211;
  padding: 0.2rem 0.3rem;
  height: 3.18rem;
  overflow-y: scroll;
}
.toast .title {
  font-size: 0.18rem;
  color: #333;
  text-align: center;
  margin-bottom: 0.3rem;
}
.toast .close_btn {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("../../assets/img/afterLoan/close_btn1.png") no-repeat center
    center;
  background-size: 100%;
  position: absolute;
  right: 0.15rem;
  top: 0.25rem;
}
.toast .box {
  color: #333;
  font-size: 0.16rem;
  font-weight: 500;
  position: relative;
}
.toast .content {
  color: #999;
  font-size: 0.12rem;
  margin-top: 0.08rem;
}
.toast .money {
  position: absolute;
  right: 0.15rem;
  color: #333;
  font-size: 0.16rem;
  top: 0.15rem;
}
</style>
<style>
.sing_box .ivu-select-selection,
.sing_box .ivu-input {
  border: 1px solid #f5f5f5;
  border-radius: 15px;
  font-size: 0.14rem;
}
.sing_box .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  font-weight: bold;
  font-size: 0.14rem;
}
.sing_box .ivu-input-icon,
.sing_box .ivu-select-arrow {
  font-size: 0.14rem;
}
.ivu-input:focus,
.ivu-select-visible .ivu-select-selection {
  outline: none;
  box-shadow: none;
}
</style>
